module.exports = __webpack_public_path__ + "static/media/deliveree.15fa00dc.png";